import React, { useState } from 'react';

const QuantityInputField = ({ onQuantityChange, quantity }) => {
  const [inputQuantity, setInputQuantity] = useState(quantity);

  const increase = () => {
    var parsed = Number(inputQuantity) + 1;
    if (!Number.isNaN(parsed) && parsed >= 1){
      setInputQuantity(parsed)
      onQuantityChange(parsed);
    }
  };
  const decrease = () => {
    var parsed = Number(inputQuantity) - 1;
    if (!Number.isNaN(parsed) && parsed >= 0){
      setInputQuantity(parsed)
      onQuantityChange(parsed);
    }
  };

  const inputQuantityBlur = (value) => {
    var parsed = Number(value);
    if (!Number.isNaN(parsed) && parsed >= 0){
      setInputQuantity(Number(parsed));
      onQuantityChange(Number(parsed));
    }
  }

  return (
      <div className={'quantity-buy-button__quantity'}>
        <div
          className="quantity-buy-button__icon"
          onClick={() => decrease()}
        >
          <i className="ph-minus color-grey-500"></i>
        </div>
        <input
          className="text-large color-grey-900"
          type="number"
          value={inputQuantity}
          onChange={(e) => setInputQuantity(e.target.value)}
          min="0"
          max="9999"
          onBlur={(e) => inputQuantityBlur(e.target.value)}
        />
        <div
          className="quantity-buy-button__icon"
          onClick={() => increase()}
        >
          <i className="ph-plus color-grey-500"></i>
        </div>
      </div>
  );
};

export default QuantityInputField;
